import { Directive, HostListener, Input } from "@angular/core";

// --------------------------------------------------------------------------------------------------------------------
// Usage:
// Default scroll: <div scrollToTop></div>
// Smooth scroll: <div [scrollToTop]="true"></div>
// --------------------------------------------------------------------------------------------------------------------

@Directive({
	selector: "[scrollToTop]",
	standalone: false
})
export class ScrollToTopDirective {
	@HostListener("click") public scrollToTop(): void {
		window.scrollTo({
			top: 0,
			left: 0,
			behavior: this.smooth ? "smooth" : "auto"
		});
	}

	@Input("scrollToTop") public smooth: boolean = false;
}
